import React, { useEffect, useMemo } from "react";
import { brandPalette } from "../../../../constants/brandPalette";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeCreateLesson } from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import {
  adminModalBodyProps,
  adminModalContentProps,
  adminModalHeaderProps,
  adminSelectStyles,
} from "../../../../components/Models/admin-modal-theme";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import Select from "react-select";
import {
  createLessonRequest,
  editLessonRequest,
} from "../../../../modules/admin-modules/lessons/Actions";
import { useState } from "react";
import { getAllChaptersRequest } from "../../../../modules/admin-modules/chapters/Actions";
import { getAllGroupsRequest } from "../../../../modules/admin-modules/groups/Actions";
const AddLesson = ({ isAdd, data, setSelectedData }) => {
  const [selected, setSelected] = useState("");
  const openLesson = useSelector((state) => state.model.isOpen3);
  const chapters = useSelector((state) => state.chapters.chapters);
  const groups = useSelector((state) => state.groups.groups);
  const isLoading = useSelector((state) => state.chapters.isLoading);

  const groupsOptions = groups?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const chaptersOptions = chapters?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const dispatch = useDispatch();
  useEffect(() => {
    if (openLesson) {
      dispatch(getAllChaptersRequest());
      dispatch(getAllGroupsRequest());
    }
  }, [openLesson]);

  const selectStyles = useMemo(() => adminSelectStyles({ menuZIndex: 50 }), []);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading
        fontSize="32px"
        fontWeight="800"
        color="var(--text-primary)"
        fontFamily="'Amiri','Tajawal',sans-serif"
      >
        {isAdd ? "Add PDF Lesson" : "Edit PDF Lesson"}
      </Heading>
      <Text
        fontSize="xs"
        mt={1}
        color="var(--text-muted)"
        textTransform="uppercase"
        letterSpacing="0.14em"
        fontWeight="700"
      >
        Upload a file and assign chapter and groups
      </Text>
    </Box>
  );
  const onSubmit = async (values) => {
    let formData = await new FormData();
    for (let key in values) {
      if (key == "groups") {
        values[key]?.map((val, idx) => formData.append(`groups[${idx}]`, val));
      } else {
        formData.append(key, values[key]);
      }
    }
    const action = () => {
      dispatch(closeCreateLesson());
      setSelectedData({});
      reset();
    };
    if (isAdd) {
      await dispatch(createLessonRequest(formData, action));
    } else {
      const totel = { ...data, ...values };
      for (let key in totel) {
        if (key == "groups") {
          totel[key]?.map((val, idx) =>
            formData.append(`groups[${idx}]`, val?.id ? val?.id : val)
          );
        } else {
          formData.append(key, totel[key]);
        }
      }
      formData.append("_method", "PUT");

      dispatch(
        editLessonRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateLesson());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openLesson}
      buttonTitle={null}
      buttonFunc={handleSubmit(onSubmit)}
      size="4xl"
      contentProps={adminModalContentProps}
      headerProps={adminModalHeaderProps}
      bodyProps={adminModalBodyProps}
      hideDefaultFooter
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={6} dir="ltr" w="100%">
          <SimpleGrid
            columns={{ base: 1, md: 2 }}
            spacingX={8}
            spacingY={6}
            alignItems="start"
          >
            <MainInput
              label="Lesson title"
              defaultValues={data?.title}
              error={errors?.title?.message}
              placeholder="Title shown in the library"
              register={register}
              name="title"
            />
            <Box gridColumn={{ base: "auto", md: "1 / -1" }}>
              <FormLabel
                m={0}
                fontSize="14px"
                fontWeight="700"
                color="var(--text-primary)"
                textAlign="left"
              >
                Overview
              </FormLabel>
              <Textarea
                mt={2}
                bg="var(--surface-muted)"
                color="var(--text-primary)"
                borderRadius="12px"
                border="1px solid"
                borderColor="var(--border-subtle)"
                defaultValue={data?.over_view}
                placeholder="Short description of the PDF"
                {...register("over_view")}
                name="over_view"
              />
            </Box>
            <Box gridColumn={{ base: "auto", md: "1 / -1" }}>
              <FormLabel
                m={0}
                mb={2}
                fontSize="14px"
                fontWeight="700"
                color="var(--text-primary)"
              >
                PDF file
              </FormLabel>
              <Button
                bg={brandPalette.primary}
                color="white"
                borderRadius="12px"
                textAlign="center"
                position="relative"
                w="100%"
                py={6}
                fontWeight="700"
                _hover={{ bg: brandPalette.accentDark }}
              >
                <Text>{selected ? selected : "Choose file to upload"}</Text>
                <Input
                  onChange={(e) => {
                    setValue("file", e.target.files[0]);
                    setSelected(e.target.files[0].name);
                  }}
                  type="file"
                  accept="application/pdf,.pdf"
                  opacity="0"
                  position="absolute"
                  w="100%"
                  h="100%"
                  cursor="pointer"
                  top={0}
                  left={0}
                />
              </Button>
            </Box>
            <FormControl>
              <VStack align="stretch" spacing={2}>
                <FormLabel
                  m={0}
                  fontSize="14px"
                  fontWeight="700"
                  color="var(--text-primary)"
                  textAlign="left"
                >
                  Chapter
                </FormLabel>
                <Select
                  options={chaptersOptions}
                  onChange={(d) => setValue("chapter_id", d.value)}
                  styles={selectStyles}
                  placeholder="Select chapter"
                  defaultValue={{
                    label: data?.chapter?.name,
                    value: data?.chapter?.id,
                  }}
                />
              </VStack>
            </FormControl>
            <FormControl gridColumn={{ base: "auto", md: "1 / -1" }}>
              <VStack align="stretch" spacing={2}>
                <FormLabel
                  m={0}
                  fontSize="14px"
                  fontWeight="700"
                  color="var(--text-primary)"
                  textAlign="left"
                >
                  Groups
                </FormLabel>
                <Select
                  options={groupsOptions}
                  isMulti
                  onChange={(d) => {
                    const selectedGroups = d.map((val) => val.value);
                    setValue("groups", selectedGroups);
                  }}
                  styles={selectStyles}
                  placeholder="Select groups"
                  defaultValue={data?.groups?.map((val) => ({
                    label: val?.name,
                    value: val?.id,
                  }))}
                />
              </VStack>
            </FormControl>
          </SimpleGrid>
          <Flex justify="flex-end" gap={6} pt={4}>
            <Button
              variant="ghost"
              color="var(--text-primary)"
              fontWeight="800"
              _hover={{ textDecoration: "underline", bg: "rgba(91, 13, 22, 0.08)" }}
              onClick={closeFunc}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              bg={brandPalette.primary}
              color="white"
              borderRadius="lg"
              px={8}
              py={6}
              fontWeight="800"
              isLoading={isLoading}
              _hover={{ bg: brandPalette.accentDark }}
              boxShadow="0 10px 24px rgba(91, 13, 22, 0.18)"
            >
              Save Changes
            </Button>
          </Flex>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddLesson;
